import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import useForm from '../../../hooks/formHook';
import '../../../styles/dashboard/settings/SettingsBilling.css';

export default function SettingsBilling() {
    const { formData, handleChange } = useForm({
        paymentMethod: ''
    });

    // Just placeholder code, but should do some api call to determine what the user's current plan is
    // To appropriately display information.
    const [billingPlan, setBillingPlan] = useState("");

    useEffect(() => {
        // API call here maybe?
        // setBillingPlan("none");
    }, []);

    return (
        <div className="SettingsBilling">
            <div className="content">
                <div className="planInfo">
                    <h2>Your Plan</h2>
                    {
                        billingPlan === "none" 
                        ?
                            <>
                                <h3>Cancelled</h3>
                                <p className="nextPayment">No upcoming payments.</p> 
                            </>
                        : 
                            <>
                                <h3>$11/month</h3>
                                <p className="nextPayment">Next payment $11 USD on 6/30/2020</p>
                                <h4>VISA **** **** **** 6652</h4>
                                <Link
                                to="/dashboard/settings/cancelsubscription"
                                className="cancel-subscription">Cancel Subscription</Link>
                            </>
                    }
                </div>
                <form 
                className={`formDashboard ${billingPlan !== 'none' ? 'push-down' : ''}`}
                onSubmit={(e) => {e.preventDefault(); console.log(e)}}>
                    <label htmlFor="paymentMethod">{billingPlan === "none" ? "Start your subscription again for $11/month" : 
                    "Change Payment Method?"}</label>
                    <input 
                    type="text"
                    name="paymentMethod"
                    value={formData.paymentMethod}
                    placeholder="Card Number MM/YY CVV" 
                    onChange={handleChange} />
                    <input 
                    type="submit" 
                    className="alert-button"
                    value={billingPlan === "none" ? "Start Subscription" : "Save Payment Method"} />
                </form>
            </div>
        </div>
    )
}